//get current active tab
export const currentTab = (state: any) => {
  return state.currentTab;
};
//get sidebar visible property
export const sideBarVisible = (state: any) => {
  return state.sideBarVisible;
};
//is user logged in
export const isLoggedIn = (state: any) => {
  return state.isLoggedIn;
};

export const showToast = (state: any) => {
  return state.showToast;
};

export const roleList = (state: any) => {
  return state.roles;
};

export const getLogo = (state: any) => {
  return state.logo;
};

export const shipList = (state: any) => {
  return state.ships;
};

export const getInspectionFirstStepData = (state: any) => {
  return state.inspectionFirstStepData;
};

export const getInspectionData = (state: any) => {
  return state.inspectionData;
};

export const getshipFromVOP = (state: any) => {
  return state.vopShips;
};

//get current active action plan
export const currentTabActionPlan = (state: any) => {
  return state.currentTabActionPlan;
};

export const getInspectionDetailsList = (state: any) => {
  return state.inspectionDetailList;
};

export const getDeckImage = (state: any) => {
  return state.deckImage;
};

export const userDetails = (state: any) => {
  return state.userDetails;
};

export const userType = (state: any) => {
  return state.userType;
};

// export const getInspectionList = (state: any) => {
//   return state.deckImage;
// };
